import React, { useEffect } from 'react'
import HistoricalOrdersCnn from '../../Home/connected/HistoricalOrdersCnn'
import { Typography, Divider } from '@material-ui/core'
import { useDispatch } from 'react-redux'
import { getSupplierOrdersAsyncThunk } from '../actions/SupplierActions'
import { SupplierOrdersProps } from '../connected/SupplierOrdersCnn'
import SupplierOrdersTable from './SupplierOrdersTable'


export default function SupplierOrders({ getSupplierOrdersBusy, supplierOrders }: SupplierOrdersProps) {
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(getSupplierOrdersAsyncThunk())
    }, [])

    return (
        <div>
            {supplierOrders &&
                <>
                    <SupplierOrdersTable paging={false} title={"Your upcoming orders"} search={false} orders={supplierOrders?.awaitingDelivery!} />
                    <br/>
                    <br/>
                    <SupplierOrdersTable paging={true} title={"Your historical orders"} search={true} orders={supplierOrders?.historical!} />
                </>
            }
        </div>
    )
}